import { FC, ReactNode, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, useMediaQuery, AppBarProps, IconButton, Stack, Box } from '@mui/material';
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import useConfig from '../../../hooks/useConfig';
import { useMenu } from '../../../store/menu';
import { MenuOrientation } from '../../../types/config';
import { Menu, MenuOpenOutlined } from '@mui/icons-material';
import { getNightOrDayPalette } from '../../../utils/getNightOrDayPalette';

const Header: FC = () => {
	const theme = useTheme();
	const downLG = useMediaQuery(theme.breakpoints.down('lg'));
	const { menuOrientation } = useConfig();
	const { state, openDrawer } = useMenu();

	const menu = state;
	const { drawerOpen } = menu;

	const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

	// header content
	const headerContent = useMemo(() => <HeaderContent />, []);

	// common header
	const mainHeader: ReactNode = (
		<Stack>
			<Toolbar
				sx={{
					justifyContent: 'space-between',
					alignItems: 'center',
					borderBottom: (theme) => `1px solid ${theme.palette[getNightOrDayPalette(theme)][200]}`,
				}}
			>
				{!isHorizontal ? (
					<IconButton
						onClick={() => openDrawer(!drawerOpen)}
						sx={{ color: (theme) => theme.palette[getNightOrDayPalette(theme)][500], bgcolor: 'transparent', ml: { xs: 0, lg: -2 } }}
					>
						{!drawerOpen ? <Menu /> : <MenuOpenOutlined />}
					</IconButton>
				) : null}
				{!downLG && (
					<Box px={2} py={0.75} width={'40%'} maxWidth={'450px'} />
				)}
				{headerContent}
			</Toolbar>
		</Stack>
	);

	// app-bar params
	const appBar: AppBarProps = {
		position: 'relative',
		color: 'inherit',
		elevation: 0,
		sx: {
			borderBottom: `1px solid ${theme.palette.divider}`,
			marginLeft: 'auto',
			width: '100%',
			gridArea: 'menu',
		},
	};

	return (
		<>
			{!downLG ? (
				<AppBarStyled open={drawerOpen} {...appBar}>
					{mainHeader}
				</AppBarStyled>
			) : (
				<AppBar {...appBar} sx={{ position: 'relative', top: 0, width: '100%', zIndex: 'unset' }}>
					{mainHeader}
				</AppBar>
			)}
		</>
	);
};

export default Header;
